import React from 'react';
import { css } from 'aphrodite/no-important';

import style from './style';

const IntroText = () => (
  <div className={ css(style.container) }>
    <p className={ css(style.paragraph) }>Over the past year,
    we've been able to work alongside many different teams at
    Facebook to ship a wide range of products and experiences
    that have helped make the world more open and connected.</p>
  </div>
);



export default IntroText;



// WEBPACK FOOTER //
// ./src/components/IntroText/index.js